module.exports = {
	"articleTitle1": "The Main Street Allure",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "The Raven's Club",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/arts/ann-arbor-film-fest",
	"articleSnippet1": "Oct 23, 2011 ... The going rate on Main Street for a cocktail — judging by the prices at Rush \nStreet, the Black Pearl and the Ravens Club — is about $9.",
	"articleSnippet2": "Mar 28, 2012 ... ... discuss movies face-to-face with the artists who created them, jump locations (\nthe Michigan Theater to the Raven's Club to Sava's) to catch as ...",
	"foodRecommendations": [],
	"articleTitle2": "Ann Arbor Film Festival - ",
	"address": "207 S Main St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.280168,
		"lng": -83.74831
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/ravensclub.json
// module id = 957
// module chunks = 0